import React, { useEffect, useState } from "react";
import { BsCapslockFill } from "react-icons/bs";

export default function ScrollToTop() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="top-to-btm">
      {showTopBtn && (
        <BsCapslockFill
          className="icon-position icon-style"
          onClick={goToTop}
        />
      )}
    </div>
  );
}
